export default {
  from: 'fra',
  select: 'Velg',
  deal: 'tilbud',
  deals: 'tilbud',
  total: 'sammenlagt',
  total_fr: '',
  pp: 'pp',
}
